import { atom } from "jotai";

export const isDraggingNodeAtom = atom(false);

isDraggingNodeAtom.debugLabel = "isDraggingNodeAtom";
